
export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.contract(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
           this.data = this.$utils.conv(resp.data,{'createDatetime':'datetime' , 'expiredTime':'datetime'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="合同详情" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="合同编号">{data.contractNo}</sl-detail-list-item>
          <sl-detail-list-item title="合同类型">{data.contractType}</sl-detail-list-item>
          <sl-detail-list-item title="甲方名称">{data.partyAName}</sl-detail-list-item>
          <sl-detail-list-item title="乙方名称">{data.partyBName}</sl-detail-list-item>
          <sl-detail-list-item title="文件名称">{data.name}</sl-detail-list-item>
          <sl-detail-list-item title="合同有效期">{data.expire}</sl-detail-list-item>
          <sl-detail-list-item title="合同年限">{data.expire}</sl-detail-list-item>
          <sl-detail-list-item title="到期时间">{data.expiredTimeText}</sl-detail-list-item>
          <sl-detail-list-item title="创建人">{data.creator}</sl-detail-list-item>
          <sl-detail-list-item title="创建时间">{data.createDatetimeText}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}